import { useRecoilValue } from 'recoil'
import type { GetUser } from '@messenger/types'
import { userAtom } from '@/atoms/_globalAtoms'
import { userTypes } from '@messenger/consts'

/**
 * Whether a user record belongs to a super admin. Only the record's type
 * counts: the role atom, which a designer or QC tab sets to messenger-user,
 * and `actAsAdmin` play no part. False while there is no record yet.
 */
export const isSuperAdmin = (user: GetUser | null | undefined): boolean =>
  user?.type === userTypes.superAdmin

/**
 * Whether the signed-in user is a super admin. Narrower than `useIsAdmin`,
 * which also admits corporation admins and users acting as admin, and than
 * `useIsInternalAdmin`, which also admits designer and QC tabs. It decides
 * what the UI shows, such as the links to the admin tools, and nothing more.
 */
export const useIsSuperAdmin = (): boolean =>
  isSuperAdmin(useRecoilValue(userAtom))
